// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"22198a5e","918":"345523b9"}[chunkId] + ".chunk.js";
};